import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["text"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { AppAlertsContext } from '@infl-ts/ui-app-alerts';
import { hubApi } from '@infl-ts/util-hub-axios-instance';
import { makeDecodeError } from '@infl-ts/util-make-apollo-decoded';
import { Box, Divider, List, ListItemButton, ListSubheader } from '@mui/material';
import * as E from 'fp-ts/Either';
import { flow, pipe } from 'fp-ts/function';
import * as TE from 'fp-ts/TaskEither';
import * as t from 'io-ts';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var ExportResponse = t.type({
  message: t.string
});

var getChallengeUuid = function getChallengeUuid(id) {
  return id.replace('challenge_', '');
};

var handleExportResponsesClick = function handleExportResponsesClick(showAlert, challengeId) {
  return pipe(hubApi().request({
    url: "/api/crm_challenges/".concat(getChallengeUuid(challengeId), "/export_responses"),
    method: 'post'
  }), TE.chainEitherKW(flow(function (response) {
    return ExportResponse.decode(response.data);
  }, E.mapLeft(makeDecodeError))), TE.match(function () {
    return showAlert({
      severity: 'error',
      message: 'Something went wrong. Please try again.',
      duration: 'medium'
    });
  }, function (_ref) {
    var message = _ref.message;
    return showAlert({
      severity: 'success',
      message: message,
      duration: 'medium'
    });
  }))();
};

var AdminListItem = function AdminListItem(_ref2) {
  var text = _ref2.text,
      props = _objectWithoutProperties(_ref2, _excluded);

  return /*#__PURE__*/_jsx(ListItemButton, _objectSpread(_objectSpread({
    alignItems: "flex-start"
  }, props), {}, {
    "data-element": "ListItemButton",
    "data-component": "AdminListItem",
    "data-source-file": "admin-actions.tsx",
    children: text
  }));
};

var AdminLinks = function AdminLinks(_ref3) {
  var challengeId = _ref3.challengeId;

  var _useContext = useContext(AppAlertsContext),
      showAlert = _useContext.showAlert;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsxs(List, {
    "data-element": "List",
    "data-component": "AdminLinks",
    "data-source-file": "admin-actions.tsx",
    children: [/*#__PURE__*/_jsx(ListSubheader, {
      disableSticky: true,
      "data-element": "ListSubheader",
      "data-component": "AdminLinks",
      "data-source-file": "admin-actions.tsx",
      children: t('Admin only')
    }), /*#__PURE__*/_jsx(AdminListItem, {
      onClick: function onClick() {
        return window.open("/corporate/challenges/".concat(getChallengeUuid(challengeId)), '_blank');
      },
      text: t('View responses'),
      "data-element": "AdminListItem",
      "data-source-file": "admin-actions.tsx"
    }), /*#__PURE__*/_jsx(AdminListItem, {
      onClick: function onClick() {
        return handleExportResponsesClick(showAlert, challengeId);
      },
      text: t('Export response data'),
      "data-element": "AdminListItem",
      "data-source-file": "admin-actions.tsx"
    }), /*#__PURE__*/_jsx(AdminListItem, {
      onClick: function onClick() {
        return window.open("/corporate/challenges/".concat(getChallengeUuid(challengeId), "/edit"), '_blank');
      },
      text: t('Edit Challenge'),
      "data-element": "AdminListItem",
      "data-source-file": "admin-actions.tsx"
    })]
  });
};

var AdminActions = function AdminActions(_ref4) {
  var challengeId = _ref4.challengeId,
      isCorporateAdmin = _ref4.isCorporateAdmin,
      hideSaveForLater = _ref4.hideSaveForLater;
  return isCorporateAdmin ? /*#__PURE__*/_jsxs(Box, {
    sx: {
      display: 'flex',
      flexDirection: 'column'
    },
    children: [hideSaveForLater ? null : /*#__PURE__*/_jsx(Divider, {}), challengeId && /*#__PURE__*/_jsx(AdminLinks, {
      challengeId: challengeId
    })]
  }) : null;
};

export default AdminActions;